export default "__VITE_ASSET__b410abf2__"